'use client';

import dynamic from 'next/dynamic';
import { z } from 'zod';

const NewsletterComponent = dynamic(() => import('./newsletter-component'));

export const SubscribeSchema = z.object({ email: z.string().min(1).email() });
export type FormData = z.infer<typeof SubscribeSchema>;
export const Newsletter = () => {
  return <NewsletterComponent></NewsletterComponent>;
};
